import View from '../common/Icons/View';
import Return from '../common/Icons/Return';
import Time from '../common/Icons/Time';

const icons = {
  View,
  Return,
  Time,
};

export default icons;
